import PortalClient from "../Component/PortalClient";

function getCommissionData(documentId) {
    return PortalClient.get(`/commission/get/${documentId}`)
        .then(({ data }) => Promise.resolve(data));
}

export const CommissionService = {
    getCommissionData,
};